module.exports = __webpack_public_path__ + "media/images/costumes/top/wasou/thumbnail-2-46243fed312ed2e786b6853acef6d29f.jpg";